// stores/favorites.ts
import { defineStore } from 'pinia';

export const useFavoritesStore = defineStore('favorites', {
  state: () => ({
    favorites: [] as string[], // Array of favorite names
  }),
  actions: {
    addFavorite(name: string) {
      if (!this.favorites.includes(name)) {
        this.favorites.push(name);
      }
    },
    removeFavorite(name: string) {
      this.favorites = this.favorites.filter((fav) => fav !== name);
    },
  },
  persist: true,
});
